import { __assign } from "tslib";
import React from 'react';
import IconWrap from '@wix/da-ds/pkg/Icons/IconWrap';
var AddEmoticon = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 2H6v2H4v2H2v11h2v2h2v2h12v-2h2v-2h2V6h-2V4h-2V2zm0 2v2h2v11h-2v2H6v-2H4V6h2V4h12zm-8 3H7v3h3V7zm7 0h-3v3h3V7zM7 13h2v2H7v-2zm8 2H9v2h6v-2zm0 0h2v-2h-2v2z", fill: "currentColor" }))));
};
AddEmoticon.displayName = 'AddEmoticon';
export default AddEmoticon;
//# sourceMappingURL=Icon.js.map